import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const dateResolver: FieldResolver = (metadata: Metadata) => {
  let date
  if (metadata.getDateTime()) {
    const dateString = new Date(Number(metadata.getDateTime()!)).toISOString()
    date = { date_: dateString }
  }

  return { date } as StreamData
}

export default dateResolver
